<div class="container">
  <div>
    <p>
      At Now, security of your information is of the highest priority.
      Multi-Factor Authentication (MFA) is a security system that requires more
      than one method of login authentication, each from independent credentials
      to verify your identity. Please answer the security question below:
    </p>
    <div class="parent">
      <ng-container [formGroup]="myform">
        <kendo-formfield>
          <kendo-label>{{ questionText }}</kendo-label>
          <kendo-floatinglabel text="{{ this.answer }}">
            <kendo-textbox
              class="k-floating-label-container k-empty"
              formControlName="answer"
              type="text"
            >
            </kendo-textbox>
          </kendo-floatinglabel>
        </kendo-formfield>
        <button kendoButton type="submit" (click)="submitForm()">Submit</button>
      </ng-container>
    </div>
  </div>
</div>
